// extracted by mini-css-extract-plugin
module.exports = {"TextButton":"TextButton_TextButton__1snnw","adminTheme":"TextButton_adminTheme__3ZUZN","primary":"TextButton_primary__2rZTn","small":"TextButton_small___zjpH"};